import { defineComponent as _defineComponent } from 'vue'
import { hyphenatedCurrentLocale } from 'bits/current_locale'
import { getLocaleName } from 'bits/locale'
import { reload } from 'bits/location'
import OzDropdownButton, {
  OzDropdownButtonColorScheme,
  OzDropdownButtonSizePreset,
} from 'library/v4/components/OzDropdownButton.vue'
import { getAnchorFromElement } from 'library/v4/components/OzPopoverModal.vue'
import { storeToRefs } from 'pinia'
import { useWindowSizeStore } from 'pinia/window_size'
import type { PopoverAnchor } from 'types'
import { computed, defineAsyncComponent, ref } from 'vue'
import { useLocale } from '@@/vuecomposables/locale'
import { uniqueId } from 'lodash-es'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocaleSelector',
  props: {
    buttonColorScheme: { default: OzDropdownButtonColorScheme.SecondaryClearText }
  },
  setup(__props: any) {

const LocaleMenu = defineAsyncComponent(() => import('vuecomponents/LocaleMenu.vue'))



const windowSizeStore = useWindowSizeStore()
const { isSmallerThanTabletPortrait, windowHeight } = storeToRefs(windowSizeStore)

const { changeLocale } = useLocale()

const currentLocale = ref(hyphenatedCurrentLocale)
const isSelectorOpen = ref(false)
const menuAnchor = ref({} as Partial<PopoverAnchor>)
const localeSelector = ref<InstanceType<typeof OzDropdownButton>>()
const currentLocaleName = computed(() => getLocaleName(currentLocale.value))

function updateMenuAnchor(): void {
  const el = localeSelector?.value?.$el
  if (!el) return
  menuAnchor.value = getAnchorFromElement(el, { top: -4, left: -4 })
}

function openMenu(): void {
  updateMenuAnchor()
  isSelectorOpen.value = true
}

function closeMenu(): void {
  isSelectorOpen.value = false
}

async function handleChangeLocale(lang: string): Promise<void> {
  isSelectorOpen.value = false

  if (currentLocale.value === lang) return

  currentLocale.value = lang
  await changeLocale(lang)

  reload()
}

// Wait for the page fully rendered before (re)calculating the menu anchor
const onPageLoad = () => {
  updateMenuAnchor()
  window.removeEventListener('load', onPageLoad)
}
window.addEventListener('load', onPageLoad)

const ariaDescribedbyId = uniqueId('locale-selector-button-description-')

return { __sfc: true,LocaleMenu, windowSizeStore, isSmallerThanTabletPortrait, windowHeight, changeLocale, currentLocale, isSelectorOpen, menuAnchor, localeSelector, currentLocaleName, updateMenuAnchor, openMenu, closeMenu, handleChangeLocale, onPageLoad, ariaDescribedbyId, OzDropdownButton, OzDropdownButtonSizePreset }
}

})